import { Img, Box, Text } from 'vvs-uikit'
import { AutoRow } from 'components/Layout/Row'
import { QuestFrequency, QuestCategory } from 'state/vvsgotchi/models'
import { questTypeToName, questSymbolToTypePostfix, questFrequencyText } from 'views/VvsGotchi/config'
import { useTranslation } from 'contexts/Localization'

import { VariableExp } from './exp/VariableExp'
import { QuestOneTime } from './frequencies/OneTime'
import { QuestDaily } from './frequencies/Daily'
import { QuestEventDriven } from './frequencies/EventDriven'

import { getExpBrief } from '../../utils/quest'

import { QuestDetailInfoProps } from './types'

const DefaultQuestDetailInfo: React.FC<QuestDetailInfoProps> = ({ quest, owner }) => {
  const { t } = useTranslation()
  const typeBrief = questTypeToName[quest.type]
  const expBrief = getExpBrief(quest, owner, t)
  const frequencyBrief = questFrequencyText[quest.frequency]

  return (
    <>
      <Box mb="32px">
        {typeBrief && (
          <AutoRow mb="12px">
            <Img src="/images/vvsGotchi/location.png" width="13.5px" ml="1px" mr="6px" />
            <Text color="black">
              {typeBrief(t)}
              {questSymbolToTypePostfix[quest.symbol]?.(t)}
            </Text>
          </AutoRow>
        )}
        {expBrief && (
          <AutoRow mb="12px">
            <Img src="/images/vvsGotchi/star.png" width="17.25px" mr="3px" />
            <Text color="black">{expBrief}</Text>
          </AutoRow>
        )}
        {frequencyBrief && (
          <AutoRow mb="12px">
            <Img src="/images/vvsGotchi/flag.png" width="17px" mr="3px" />
            <Text color="black">{frequencyBrief(t)}</Text>
          </AutoRow>
        )}
      </Box>

      {quest.variableExpRules && <VariableExp quest={quest} />}
      {quest.frequency === QuestFrequency.ONE_TIME_ONLY && quest.category !== QuestCategory.ONBOARDING && (
        <QuestOneTime />
      )}
      {quest.frequency === QuestFrequency.ONCE_A_DAY && <QuestDaily />}
      {quest.frequency === QuestFrequency.EVENT_DRIVEN && <QuestEventDriven />}
    </>
  )
}

export default DefaultQuestDetailInfo
